import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, styled, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { AirlineSeatLegroomExtraTwoTone } from '@mui/icons-material';
import Button from 'components/Button';
import Icon from '../Icon';

import { DeleteModalProps } from './types';

const Modal = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: `${theme.spacing(2)}  0px`,
    borderBottom: 0,
    textAlign: 'center'
  },
  '& .MuiDialogActions-root': {
    margin: 0
  },
  '& .MuiDialogTitle-root': {
    padding: 0,
    marginBottom: theme.spacing(2)
  },
  '& .MuiButton-root:hover': {
    boxShadow: 'none'
  }
}));

const Circle = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  // backgroundColor: 'red',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const DeleteModal = ({
  isOpen,
  type,
  handleClose,
  handleActions,
  children,
  title,
  icon,
  btnName,
  loading = false
}: DeleteModalProps) => {
  const [btn, setBtn] = useState('');
  useEffect(() => {
    setBtn(btn);
  }, [btn]);

  // const CloseModal = (event, reason) => {
  //   if (disableBackdropClick && reason === "backdropClick") {
  //     return false;
  //   }

  //   if (disableEscapeKeyDown && reason === "escapeKeyDown") {
  //     return false;
  //   }

  //   if (typeof onClose === "function") {
  //     handleClose();
  //   }
  // }

  return (
    <Modal
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: theme => ({ p: theme.spacing(3), borderRadius: 3, minWidth: 300 }) }}
      open={isOpen}
      onClose={(_, reason: string) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown' && !loading) {
          handleClose();
        }
      }}
      // onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        fontWeight={600}
        fontSize={16}
        id="alert-dialog-title"
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
      >
        <Circle
          component="span"
          sx={{ backgroundColor: type === 'delete' ? 'rgba(242, 0, 0, 0.10)' : 'rgba(0, 197, 31, 0.10);' }}
          marginBottom={2}
        >
          {type === 'delete' ? (
            <Icon name={icon} fill="red" size="32"></Icon>
          ) : (
            <Icon name={icon} fill="green" size="32"></Icon>
          )}
        </Circle>
        {title}
      </DialogTitle>
      {/* <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 15,
          color: theme => theme.palette.grey[500]
        }}
      >
        <Icon name="close-circle" />
      </IconButton> */}
      <DialogContent>{children}</DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px' }}>
        {type === 'success' ? (
          ''
        ) : (
          <Button size="medium" onClick={handleClose} color="secondary" sx={{ minWidth: '132px' }}>
            Cancel
          </Button>
        )}
        {type === 'delete' ? (
          <Button
            onClick={handleActions}
            color="error"
            size="medium"
            loading={loading}
            variant="contained"
            sx={{ minWidth: '132px' }}
          >
            {btnName}
          </Button>
        ) : (
          <Button size="medium" onClick={handleActions} color="success" sx={{ minWidth: '132px' }}>
            {btnName}
          </Button>
        )}
      </DialogActions>
    </Modal>
  );
};

export default DeleteModal;
